import React from 'react';

interface ProfileFormProps {
    nickname: string;
    statusMessage: string;
    onNicknameChange: (value: string) => void;
    onStatusMessageChange: (value: string) => void;
}

export const ProfileForm: React.FC<ProfileFormProps> = ({
    nickname,
    statusMessage,
    onNicknameChange,
    onStatusMessageChange
}) => {
    return (
        <div className="profile-section">
            <h2 className="section-title">기본 정보</h2>
            <div className="form-group">
                <label htmlFor="nickname">닉네임</label>
                <input
                    id="nickname"
                    type="text"
                    value={nickname}
                    onChange={(e) => onNicknameChange(e.target.value)}
                    className="input-field"
                />
            </div>
            <div className="form-group">
                <label htmlFor="statusMessage">상태 메시지</label>
                <input
                    id="statusMessage"
                    type="text"
                    value={statusMessage}
                    onChange={(e) => onStatusMessageChange(e.target.value)}
                    className="input-field"
                />
            </div>
        </div>
    );
};
